<page-toolbar [pageActions]="pageActions" [title]="title"></page-toolbar>

<page-content>
  <smart-input [(model)]="driver" key="path"></smart-input>

  <mat-card appearance="outlined">
    <h2>{{ 'driver.steps' | translate }}</h2>

    <div class="main-actions">
      <button (click)="createStep()" class="ibexfusion-raised-button" mat-button>{{ 'driver.createStep' | translate }}
      </button>
    </div>

    <div class="table-header">
      <div class="title">{{'general.title' | translate}}</div>
    </div>

    <div (cdkDropListDropped)="dropStep($event)" cdkDropList class="table">
      <div *ngFor="let step of driver?.steps; let i = index" cdkDrag [cdkDragDisabled]="driver?.steps?.length <= 1" cdkDragBoundary=".table" class="table-row">
        <div *cdkDragPlaceholder class="drag-placeholder"></div>
        <div class="title">{{ step.title }}</div>
        <div class="drag">
          <button class="drag ibexfusion-icon-button" mat-icon-button matTooltip="{{'packages.installedApps.dragTip'| translate}}">
            <mat-icon>drag_indicator</mat-icon>
          </button>
        </div>
        <div class="actions">
          <button (click)="editStep(i)" class="ibexfusion-icon-button" mat-icon-button>
            <mat-icon>edit</mat-icon>
          </button>
          <button (click)="removeStep(i)" class="ibexfusion-icon-button" mat-icon-button>
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      </div>
    </div>
  </mat-card>

  <button (click)="onSave()" color="primary" mat-button mat-raised-button>Save</button>
</page-content>
